
<form>
  <div class="card text-center">
    <div class="card-header bg-primary text-left text-white font-weight-bold">
      Product Search
    </div>
    <div class="card-body mat-card">

      <div class="row">
        <div class="col-sm-6">
          <div class="form-group row text-left">
            <label for="lblOffice" class="col-sm-4 col-form-label">Product Category <span
                class="font-red-flamingo">*</span></label>
            <div class="col-sm-8">
           
              <select id="ddlProductCategory" name="ddlProductCategory" [(ngModel)]="FormModel.ProdSegmentId"
              (ngModelChange)="OnCategoryChange(FormModel.ProdSegmentId)" class="form-control">
                <option  [selected]="true" value="0">Select</option>
                <option *ngFor="let pc of ProductCategoryList"  value={{pc.prodSegmentId}}>{{pc.prodSegmentDesc}} </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group row text-left">
            <label for="lblCustomerName" class="col-sm-4 col-form-label">Product Group</label>
            <div class="col-sm-8">
                
                <select id="ddlProductGroup" name="ddlProductGroup" [(ngModel)]="FormModel.ProductGroupId"
                (ngModelChange)="OnGroupChange(FormModel.ProductGroupId)" class="form-control">
                <option  [selected]="true" value="0">--All--</option>
                <option *ngFor="let pg of ProductGroupList"  value={{pg.productGroupId}}>{{pg.productGroupDesc}} </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group row text-left">
            <label for="lblSaleCode" class="col-sm-4 col-form-label">Product Code</label>
            <div class="col-sm-8">
                <ng-select [items]="ProductCodes"
                bindLabel="productCode"
                appendTo="body"
                [(ngModel)]="selected"
                 name="ngProductCode"
                (keyup)="onProductCodeKeypress($event)" >
                </ng-select>
            </div>
          </div>

        </div>

      </div>

    </div>
    <div class="card-footer text-left">
      <div class="row">
        <div class="col-sm-2"></div>
        <div class="col-sm-6">
          <div class="form-group row">
           
            <div class="col-sm-10">
              <button type="button" class="btn btn-primary" (click)="formSubmit()" >Submit</button>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>

  <br>

</form>